"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengeCard = exports.ChallengeCardDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var card_1 = require("../elements/card");
var content_1 = require("../elements/content");
var icon_1 = require("../elements/icon");
var entity_count_label_1 = require("./entity-count-label");
var use_lang_1 = require("../../hooks/use-lang");
var entity_image_1 = require("./entity-image");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var coalesce_1 = require("../../utils/coalesce");
var entity_cell_header_1 = require("./entity-cell-header");
var entity_value_1 = require("./entity-value");
exports.ChallengeCardDefaultProps = {};
// -------- Styles -------->
var CardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var BannerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-grow: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: ", ";\n    ", ";\n  "], ["\n    flex-grow: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG())
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(18), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(2), theme_1.theme.COLOR('link-hover'))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-top: ", ";\n\n    &:first-child {\n      margin-top: 0;\n    }\n  "], ["\n    margin-top: ", ";\n\n    &:first-child {\n      margin-top: 0;\n    }\n  "])), theme_1.theme.UNIT(2))
});
var CuratorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n\n    .shp--entity-value__name {\n      color: ", ";\n    }\n  "], ["\n    ", ";\n    padding-bottom: ", ";\n    margin-bottom: ", ";\n\n    .shp--entity-value__name {\n      color: ", ";\n    }\n  "])), theme_1.theme.H_DOT_BG_END(), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.COLOR('dark'))
});
var AttributesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var FollowControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    color: ", ";\n    ", ";\n    padding-left: 1px;\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n  "], ["\n    color: ", ";\n    ", ";\n    padding-left: 1px;\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n  "])), theme_1.theme.COLOR('text'), theme_1.theme.H_DOT_BG_END(), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Card: (0, styled_components_1.default)(card_1.Card)(templateObject_12 || (templateObject_12 = __makeTemplateObject([""], [""]))),
  Image: (0, styled_components_1.default)(entity_image_1.EntityImage)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  CountLabel: (0, styled_components_1.default)(entity_count_label_1.EntityFieldCountLabel)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Attributes: styled_components_1.default.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), AttributesStyles),
  Content: (0, styled_components_1.default)(content_1.Content)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Header: (0, styled_components_1.default)(entity_cell_header_1.EntityCellHeader)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Title: styled_components_1.default.span(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Curator: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), CuratorStyles)
};
My.Card = (0, styled_components_1.default)(card_1.Card)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  ", "\n \n  &:hover {\n    ", " {\n      filter: brightness(110%);\n    }\n\n    ", " {\n      color: ", ";\n    }\n  }\n"], ["\n  ", "\n \n  &:hover {\n    ", " {\n      filter: brightness(110%);\n    }\n\n    ", " {\n      color: ", ";\n    }\n  }\n"])), CardStyles, My.Image, My.Title, theme_1.theme.COLOR('link'));
var ChallengeCard = function (props) {
  var className = props.className,
    entity = props.entity,
    path = props.path;
  var curator = entity.curator,
    organisations = entity.organisations,
    feedEntries = entity.feedEntries,
    people = entity.people,
    impactStories = entity.impactStories,
    keyIssues = entity.keyIssues;
  var t = (0, use_lang_1.useLang)();
  var defn = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var cellLabel = defn.label;
  var description = (0, coalesce_1.coalesce)(entity, ['description.text', 'openGraph.text']);
  return React.createElement(My.Card, __assign({}, props, {
    to: path,
    space: 4,
    className: className,
    image: React.createElement(My.Image, {
      entity: entity
    })
  }), React.createElement(My.Header, {
    entity: entity
  }), React.createElement(My.Title, null, entity.name), curator && React.createElement(My.Curator, {
    label: "Curator",
    entity: curator
  }), React.createElement(My.Attributes, null, React.createElement(My.CountLabel, {
    entityTypeName: "FeedEntry",
    value: feedEntries
  }), React.createElement(My.CountLabel, {
    entityTypeName: "Person",
    value: people
  }), React.createElement(My.CountLabel, {
    entityTypeName: "Organisation",
    value: organisations
  }), React.createElement(My.CountLabel, {
    entityTypeName: "ImpactStory",
    value: impactStories
  }), React.createElement(My.CountLabel, {
    entityTypeName: "KeyIssue",
    value: keyIssues
  })), description && React.createElement(My.Content, {
    tiny: true,
    html: description
  }));
};
exports.ChallengeCard = ChallengeCard;
exports.ChallengeCard.defaultProps = exports.ChallengeCardDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;